import $ from 'jquery';
import * as L from 'leaflet';
import { union } from '@turf/union';
//import './../css/map.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-icon-2x.png';
import './../scss/map.scss';

L.Marker.prototype.setIcon(L.icon({
  iconUrl: "https://static.activ-travaux.com/icons/png/location.png",
  iconSize: [32, 32],
  iconAnchor: [16, 32]
}))


// Dict for store globaly maps for made action on it later
if(!window.maps_list_ref)
  window.maps_list_ref = {};

export function init_map(id) {
  let map =  $("#" + id);

  if(map.length === 0)
    return;

  let icon = map.data('icon')

  // The concessionary detail map (.dark-map) uses a black marker icon.
  if (map.hasClass('dark-map') && icon) {
    L.Marker.prototype.setIcon(L.icon({
      iconUrl: icon,
      iconSize: [25, 41],
      iconAnchor: [16, 32]
    }))
  }

  let longitude = parseFloat(map.attr('data-target-longitude'));
  let latitude = parseFloat(map.attr('data-target-latitude'));

  if (!longitude || !latitude)
    return;

  let radius = map.attr('data-target-radius');
  let zoom = parseInt(map.attr('data-target-zoom'));
  let is_pro = map.attr('data-is-pro');
  let locations = [latitude, longitude];

  let mymap = L.map(id).setView(locations, zoom);
  // Standard full-colour OpenStreetMap tiles (replaces the desaturated
  // CartoDB "light" basemap previously used).
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: "© Les contributeurs d'<a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a>"
  }).addTo(mymap);

  if(is_pro || (!is_pro && !radius))
    L.marker(locations).addTo(mymap);
  else
    L.circle(locations, {radius: radius*1000}).addTo(mymap);
  // Dict for store globaly maps for made action on it later
  window.maps_list_ref[id] = mymap

  // Concessionary intervention area: red outline of each served commune,
  // drawn from a GeoJSON FeatureCollection (City.contour). Same look as the
  // aladom job/contact maps.
  let citiesUrl = map.attr('data-url');
  if (map.hasClass('dark-map') && citiesUrl)
    draw_intervention_area(mymap, citiesUrl);
}

// Red contour style, matching the aladom intervention-zone maps.
const ZONE_STYLE = {
  color: '#d6336c',
  weight: 2,
  fillColor: '#ff6b9d',
  fillOpacity: 0.25,
};

function draw_intervention_area(mymap, url) {
  $.ajax({url: url, type: 'get'}).done(function (data) {
    if (!data || !data.features || !data.features.length)
      return;
    // Merge every served commune into a single shape so the map shows one
    // red intervention zone, without the city-by-city internal borders.
    let shape = data;
    if (data.features.length > 1) {
      try {
        let merged = union(data);
        if (merged)
          shape = merged;
      } catch (e) {
        shape = data;  // fall back to the raw features if the union fails
      }
    }
    let layer = L.geoJSON(shape, {style: ZONE_STYLE}).addTo(mymap);
    // The merged shape has lost the per-commune properties, so the names ride
    // on a transparent layer laid over it: the zone keeps its single outline
    // while hovering still tells which commune is under the cursor. Fill stays
    // enabled (only its opacity drops) because Leaflet hit-tests the fill.
    L.geoJSON(data, {
      style: {stroke: false, fill: true, fillOpacity: 0},
      onEachFeature: function (feature, cityLayer) {
        let name = feature.properties && feature.properties.name;
        cityLayer.bindTooltip(name || "Secteur d'intervention", {sticky: true});
      },
    }).addTo(mymap);
    let bounds = layer.getBounds();
    if (bounds.isValid())
      mymap.fitBounds(bounds, {padding: [20, 20]});
  });
}

$(function() {
  init_map('map')

  // we need to invalide size for correct display map in tab when we switch on it
  $(document).on('shown.bs.tab', '[data-toggle="tab"]', function (e) {
    let maps = $($(e.target).attr('href')).find('.leaflet-container')
    maps.each(function(index) {
      let map_id= $(this).attr('id')
      if(map_id in window.maps_list_ref)
        window.maps_list_ref[map_id].invalidateSize()
    });
  })
});
